import {createApi} from '@reduxjs/toolkit/query/react';
import baseQuery from 'src/redux/api/baseQuery';
import { DetalleProductoRequest, DetalleProductoResponse, IeditarProductoRequest, IguardarProductoRequest, ProductosItemResponse, ProductosRequest } from './types/productos';

/**
 * API para la gestión de productos de proyecto
 * @see https://redux-toolkit.js.org/rtk-query/overview
 * @see https://redux-toolkit.js.org/rtk-query/usage/customizing-queries
 *
 */
export const productosApi = createApi({
	reducerPath: 'productosApi',
	baseQuery,
	tagTypes: ['productos'],
	endpoints: (builder) => ({
		obtenerProductos: builder.query<ProductosItemResponse, ProductosRequest>({
			query({proyectoId, paginador}) {
				return {
					url: 'v1/productos',
					method: 'GET',
					credentials: 'include',
					params: {
						proyectoId,
						...paginador
					}
				};
			},
			providesTags: ['productos']
		}),
		obtenerProductoPorId: builder.query<DetalleProductoResponse, DetalleProductoRequest>({
			query({productoId}) {
				return {
					url: `v1/productos/${productoId}`,
					method: 'GET',
					credentials: 'include',
				};
			},
		}),
		guardarProducto: builder.mutation<void, IguardarProductoRequest>({
			query(body) {
				return {
					url: 'v1/productos',
					method: 'POST',
					credentials: 'include',
					body,
				};
			},
			invalidatesTags: ['productos'],
		}),
		editarProducto: builder.mutation<void, IeditarProductoRequest>({
			query({productoId,...body}) {
				return {
					url: `v1/productos/${productoId}`,
					method: 'PUT',
					credentials: 'include',
					body,
				};
			},
			invalidatesTags: ['productos'],
		}),
	}),
});

export const {
	useObtenerProductosQuery,
	useObtenerProductoPorIdQuery,
	useGuardarProductoMutation,
	useEditarProductoMutation
} = productosApi;
